<template>
  <main-layout wide>
    <MyClientsListContainer />
    <ImportClientsContainer />
  </main-layout>
</template>

<script>
import MyClientsListContainer from '@/components/Widgets/MyClientsListContainer';
import ImportClientsContainer from '@/components/Widgets/ImportClientsContainer';

export default {
  name: 'AssociateClientsMy',
  components: {
    MyClientsListContainer,
    ImportClientsContainer,
  },
};
</script>

<style lang="scss" scoped>
</style>
